import {
  ExchangeFeeInfo as KitExchangeFeeInfo,
  ExchangeIcon,
} from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../../store/globalState";

export interface ExchangeFeeInfoProps {
  fee: string;
  currency: string;
}

export const ExchangeFeeInfo: React.FC<ExchangeFeeInfoProps> = ({
  fee,
  currency,
}) => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { bodyCopy, textColorBtn } = theme.whiteView;

  return (
    <KitExchangeFeeInfo
      fee={fee}
      currency={currency}
      chipBackground={bodyCopy}
      textColor={textColorBtn}
      translations={{
        rateText: t("exchange.rate", {
          from: "{from}",
          rate: "{rate}",
          to: "{to}",
        }),
      }}
      ExchangeIcon={
        <ExchangeIcon size={12} colors={[textColorBtn, textColorBtn]} />
      }
    />
  );
};
